import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { DirectiveModule } from '@fcom/common/directives/directive.module';
import { ButtonComponent } from '@fcom/ui-components/components/buttons/button/button.component';
import { IconComponent } from '@fcom/ui-components/components/icons/icon/icon.component';
import { LoaderComponent } from '@fcom/ui-components/components/loader/loader.component';
import { RadioItemGroupComponent } from '@fcom/ui-components/components/forms/radio-item-group/radio-item-group.component';
import { TextInputComponent } from '@fcom/ui-components/components/forms/text-input/text-input.component';
import { TrapFocusDirective } from '@fcom/ui-components/directives/trap-focus/trap-focus.directive';
import { UiTranslateModule } from '@fcom/ui-translate';
import { ComponentsModule, FragmentService } from '@fcom/common';
import { GtmModule } from '@fcom/common/gtm/gtm.module';

import { PreChatComponent } from './components/pre-chat/pre-chat.component';
import { SalesforceChatService } from './services/salesforce-chat.service';
import { ChatComponent } from './components/chat/chat.component';
import { ChatGlobalVisibilityComponent } from './components/chat-global-visibility/chat-global-visibility.component';
import { ChatUserFormComponent } from './components/chat-user-form/chat-user-form.component';
import { AgentforceChatService } from './services/agentforce-chat.service';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    DirectiveModule,
    UiTranslateModule,
    ButtonComponent,
    IconComponent,
    TrapFocusDirective,
    LoaderComponent,
    RadioItemGroupComponent,
    TextInputComponent,
    GtmModule,
    ReactiveFormsModule,
  ],
  declarations: [ChatComponent, PreChatComponent, ChatGlobalVisibilityComponent, ChatUserFormComponent],
  exports: [ChatComponent, ChatGlobalVisibilityComponent],
  providers: [SalesforceChatService, FragmentService, AgentforceChatService],
})
export class ChatModule {}
